import { LABELS, MENU } from '@/constants/common/message.constants'

import { type TourImportJobExEntity } from '../..'

/**
 * 運行実績取込種別
 */
export type TourImportJobType = TourImportJobExEntity['type']

export const TOUR_IMPORT_JOB_TYPE = {
  /** ファイル */
  FILE: 'FILE',
  /** 配車板 */
  DISPATCH: 'DISPATCH'
} as const satisfies Record<TourImportJobType, TourImportJobType>

export const TOUR_IMPORT_JOB_TYPE_LABEL = {
  [TOUR_IMPORT_JOB_TYPE.FILE]: LABELS.FILE,
  [TOUR_IMPORT_JOB_TYPE.DISPATCH]: MENU.VEHICLE_DISPATCH_BOARD
} as const satisfies Record<TourImportJobType, string>
